const $inject = ['$q'];

const lbMicrosoftMapsScriptService = function ($q) {
  var service = {};

  service.loaded = false;
  service.loading = false;
  service.promiseArray = [];

  service.load = function load() {
    let deferred = $q.defer();

    if(!service.loaded && !service.loading) {
      service.loading = true;
      buildScript(function () {
        deferred.resolve();
        service.loaded = true;
        service.loading = false;
        service.promiseArray.forEach((func)=>{
            func();
        })
      });
    } else if(!service.loaded && service.loading)  {
      service.promiseArray.push( deferred.resolve);
    } else if(service.loaded && !service.loading) {
      deferred.resolve();
    }

    return deferred.promise;
  };
  return service;
};

function buildScript( callBack ){
  var tag = document.createElement("script");
  tag.src = "https://www.bing.com/api/maps/mapcontrol?callback=loadMapScenario";
  document.getElementsByTagName("head")[0].appendChild(tag);

  window.loadMapScenario = callBack;
}

lbMicrosoftMapsScriptService.$inject = $inject;

export default lbMicrosoftMapsScriptService;



// WEBPACK FOOTER //
// ./src/services/lbMicrosoftMapsScriptService.js